module.exports = __webpack_public_path__ + "img/morflax_og.803cff79.jpg";